<template>
  <page-layout title="能耗统计">
    <a-row :gutter="[16,16]">
      <a-col :span="18">
        <a-row :gutter="[16,16]">
          <a-col :span="6" >
            <a-card>
              <a-row>
                <a-col :span="24">
                  <chart-card :total="totalElectricity.today" title="本月用电量" unit="kWh">
                    <div>
                      <trend :flag="totalElectricity.weekflag" style="margin-right: 16px;">
                        <span slot="term">同比</span>
                        {{totalElectricity.weeknum}}
                      </trend>
                    </div>
                  </chart-card>
                </a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col :span="6" >
            <a-card>
              <a-row>
                <a-col :span="24">
                  <chart-card :total="avgElectricity.today" title="日均用电量" unit="kWh">
                    <div>
                      <trend :flag="avgElectricity.weekflag" style="margin-right: 16px;">
                        <span slot="term">同比</span>
                        {{avgElectricity.weeknum}}
                      </trend>
                    </div>
                  </chart-card>
                </a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col :span="6" >
            <a-card>
              <a-row>
                <a-col :span="24">
                  <chart-card :total="avgPowerFactor.today" title="平均功率因数">
                    <div>
                      <trend :flag="avgPowerFactor.weekflag" style="margin-right: 16px;">
                        <span slot="term">同比</span>
                        {{avgPowerFactor.weeknum}}
                      </trend>
                    </div>
                  </chart-card>
                </a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col :span="6" >
            <a-card>
              <a-row>
                <a-col :span="24">
                  <chart-card prefix="进水" :total="waterinLateFlow" title="吨水用电量" unit="kWh">
                    <div class="chart-card-header">
                      <div class="total"><span class="prefix">产水</span><span>{{ wateroutLateFlow }}</span><span class="unit">kWh</span></div>
                    </div>
                  </chart-card>
                </a-col>
              </a-row>
            </a-card>
          </a-col>
        </a-row>
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-card size="small" style="width: 100%" title="日用电量">
              <template slot="extra" type="link">
                <a-tooltip title="上月">
                  <a>
                    <a-icon @click="timeChange(-1)" class="search-icon-m" type="backward" />
                  </a>
                </a-tooltip>
                <a>
                  <a-tooltip title="下月">
                    <a-icon @click="timeChange(1)" class="search-icon-m" type="forward" />
                  </a-tooltip>
                </a>
              </template>
              <v-chart :option="dailyElectricityOption" style="width: 100%; height: 235px; background-color: #fff" />
            </a-card>
          </a-col>
        </a-row>
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-card size="small" style="width: 100%" title="功率因数">
              <v-chart :option="dailyFactorOption" style="width: 100%; height: 235px; background-color: #fff" />
            </a-card>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row :gutter="[16,16]">
          <a-col :span="24" >
            <chart-card>
              <a-row :gutter="[16,16]">
                  <a-col :span="24" align="middle">
                      <a-radio-group v-model:value="timeRangeRadio" @change="timeRangeRadioChange()" button-style="solid">
                          <a-radio-button value="1">今日</a-radio-button>
                          <a-radio-button value="2">本周</a-radio-button>
                          <a-radio-button value="3">本月</a-radio-button>
                          <a-radio-button value="4">上月</a-radio-button>
                          <a-radio-button value="5">本年</a-radio-button>
                      </a-radio-group>
                  </a-col>
              </a-row>
              <a-row :gutter="[16,16]">
                  <a-col :span="24" align="middle">
                      <a-range-picker @change="timeRangeChange()" @ok="timeRangeChange()" format="YYYY-MM-DD" v-model="timeRange" />
                  </a-col>
              </a-row>
            </chart-card>
          </a-col>
        </a-row>
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-card size="small" style="width: 100%" title="分项占比">
              <v-chart :option="itemProportionOption" style="width: 100%; height: 235px; background-color: #fff" />
            </a-card>
          </a-col>
        </a-row>
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-card size="small" style="width: 100%" title="用电最多TOP10">
              <rank-list :list="rankList" />
            </a-card>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </page-layout>
</template>

<script>
  import moment from 'dayjs'
  import PageLayout from '@/components/page/PageLayout'
  import ChartCard from '@/components/ChartCard'
  import ACol from "ant-design-vue/es/grid/Col"
  import ATooltip from "ant-design-vue/es/tooltip/Tooltip"
  import RankList from '@/components/chart/RankList'
  import LineChartMultid from '@/components/chart/LineChartMultid'
  import HeadInfo from '@/components/tools/HeadInfo.vue'
  import MiniArea from '@/components/chart/MiniArea'
  import { httpAction, getAction } from '@/api/manage'

  import Trend from '@/components/Trend'
  import { use } from 'echarts/core'
  import { LegendComponent, VisualMapComponent, TitleComponent, CalendarComponent, ToolboxComponent,
    TooltipComponent, GridComponent, MarkLineComponent, MarkPointComponent } from 'echarts/components'
  import { LineChart, PieChart, BarChart } from 'echarts/charts'
  import { CanvasRenderer } from 'echarts/renderers';

  use([LineChart, PieChart, LegendComponent, VisualMapComponent, TitleComponent, CalendarComponent, ToolboxComponent,
    TooltipComponent, GridComponent, MarkLineComponent, MarkPointComponent, BarChart, CanvasRenderer])

  export default {
    name: "Analysis",
    components: {
      PageLayout,
      ATooltip,
      ACol,
      ChartCard,
      RankList,
      Trend,
      LineChartMultid,
      HeadInfo
    },
    data () {
      return {
        month: moment().format('YYYY-MM'),
        timeRange: [ moment().startOf('months').format('YYYY-MM-DD'), moment().endOf('months').format('YYYY-MM-DD')],
        timeRangeRadio: '3',
        loading: true,
        center: null,
        rankList: [],
        visitFields: ['ip', 'visit'],
        indicator: <a-icon type="loading" style="font-size: 24px" spin />,
        analysis:{
          name : '能耗统计'
        },
        totalElectricity: {
          today: '0',
          weekflag: 'up',
          weeknum: '0%',
        },
        avgElectricity: {
          today: '0',
          weekflag: 'up',
          weeknum: '0%',
        },
        avgPowerFactor: {
          today: '0',
          weekflag: 'up',
          weeknum: '0%',
        },
        dailyElectricityDays: [],
        waterinLateFlow: '0',
        wateroutLateFlow: '0',
        url: {
          energyFlow: '/monitor/energy/energyFlow',
          avgFlow: '/monitor/energy/avgFlow',
          factorFlow: '/monitor/energy/factorFlow',
          tonOfElecFlow: '/monitor/energy/tonOfElecFlow',
          dailyElectricity: '/monitor/energy/dailyElectricity',
          dailyFactor: '/monitor/energy/dailyFactor',
          itemProportion: '/monitor/energy/itemProportion',
          mostElectricityTop10: '/monitor/energy/mostElectricityTop10',
        },
        dailyElectricityOption: {},
        dailyElecMonth1: '本月',
        dailyElecMonth2: '上月',
        dailyFactorOption: {},
        itemProportionOption:{},
      }
    },
    created () {
      this.getEnergyFlow();
      this.getAvgDailyEnergy();
      this.getAvgPowerFactor();
      this.getPerTonOfWaterElectricity();
      this.getDailyElectricity();
      this.getDailyFactor();
      this.getItemProportion();
      this.getMostElectricityTop10();
    },
    methods: {
      timeChange (mouth) {
        const startTime = this.month;
        const newStartTime = moment(startTime).add(mouth, 'months').format('YYYY-MM');
        this.month = newStartTime;
        this.getDailyElectricity();
        this.getDailyFactor();
      },
      timeRangeRadioChange(){
        //今日
        if(this.timeRangeRadio == '1'){
          this.timeRange = [ moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        }else if(this.timeRangeRadio == '2'){
          //本周
          this.timeRange = [ moment().startOf('week').add(1, 'day').format('YYYY-MM-DD'), moment().endOf('week').add(1, 'day').format('YYYY-MM-DD')]
        }else if(this.timeRangeRadio == '3'){
          //本月
          this.timeRange = [ moment().startOf('months').format('YYYY-MM-DD'), moment().endOf('months').format('YYYY-MM-DD')]
        }else if(this.timeRangeRadio == '4'){
          //上月
          this.timeRange = [ moment().subtract(1, 'months').startOf('months').format('YYYY-MM-DD'), moment().subtract(1, 'months').endOf('months').format('YYYY-MM-DD')]
        }else if(this.timeRangeRadio == '5'){
          //本年
          this.timeRange = [ moment().startOf('years').format('YYYY-MM-DD'), moment().endOf('years').format('YYYY-MM-DD')]
        }else if(this.timeRangeRadio == '6'){
          //去年
          this.timeRange = [ moment().add(-1, 'years').startOf('months').format('YYYY-MM-DD'), moment().add(-1, 'years').month(11).endOf('months').format('YYYY-MM-DD')]
        }
        this.timeRangeChange();
      },
      timeRangeChange(){
        this.getItemProportion();
        this.getMostElectricityTop10();
      },
      //本月用电量
      getEnergyFlow () {
        getAction(this.url.energyFlow, {}).then(res => {
          if (res.success && res.result) {
            const totalElectricityToday = res.result.totalElectricity || 0;
            const totalElectricityWeekNum = parseFloat(res.result.lastTotalElectricityPercent).toFixed(2);
            const totalElectricityWeekFlag = (totalElectricityWeekNum) < 0 ? 'down' : 'up';
            this.totalElectricity = Object.assign(
              this.totalElectricity,
              {
                today: parseFloat(totalElectricityToday).toFixed(2),
                weekflag: totalElectricityWeekFlag,
                weeknum: totalElectricityWeekNum,
              }
            );
          }
        });
      },
      //日均用电量
      getAvgDailyEnergy () {
        getAction(this.url.avgFlow, {}).then(res => {
          if (res.success && res.result) {
            const avgElectricityToday = res.result.avgElectricity || 0;
            const avgElectricityWeekNum = parseFloat(res.result.lastAvgElectricityPercent).toFixed(2);
            const avgElectricityWeekFlag = (avgElectricityWeekNum) < 0 ? 'down' : 'up';
            this.avgElectricity = Object.assign(
              this.avgElectricity,
              {
                today: parseFloat(avgElectricityToday).toFixed(2),
                weekflag: avgElectricityWeekFlag,
                weeknum: avgElectricityWeekNum,
              }
            );
          }
        });
      },
      //平均功率因数
      getAvgPowerFactor () {
        getAction(this.url.factorFlow, {}).then(res => {
          if (res.success && res.result) {
            const avgPowerFactorToday = res.result.avgPowerFactor || 0;
            const avgPowerFactorWeekNum = parseFloat(res.result.lastAvgPowerFactorPercent).toFixed(2);
            const avgPowerFactorWeekFlag = (avgPowerFactorWeekNum) < 0 ? 'down' : 'up';
            this.avgPowerFactor = Object.assign(
              this.avgPowerFactor,
              {
                today: parseFloat(avgPowerFactorToday).toFixed(2),
                weekflag: avgPowerFactorWeekFlag,
                weeknum: avgPowerFactorWeekNum,
              }
            );
          }
        });
      },
      //吨水用电量
      getPerTonOfWaterElectricity () {
        getAction(this.url.tonOfElecFlow, {}).then(res => {
          if (res.success && res.result) {
            this.waterinLateFlow = parseFloat(res.result.waterinLateFlow).toFixed(2);
            this.wateroutLateFlow = parseFloat(res.result.wateroutLateFlow).toFixed(2);
          }
        });
      },
      //日用电量
      getDailyElectricity(){
        if(this.month == moment().format('YYYY-MM')){
          this.dailyElecMonth1 = '本月'
          this.dailyElecMonth2 = '上月'
        }else{
          this.dailyElecMonth1 = this.month
          //计算年份上一月
          let preMonth = moment(this.month).add(-1, 'months').format('YYYY-MM');
          this.dailyElecMonth2 = preMonth
        }
        getAction(this.url.dailyElectricity, {startTime:this.month}).then(res => {
          if (res.success && res.result) {
            this.dailyElectricityDays = res.result.days
            let staits = res.result.staits
            let lastStair = res.result.lastStair
            this.dailyElectricityOption = {
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: [this.dailyElecMonth1, this.dailyElecMonth2]
              },
              xAxis: [
                {
                  type: 'category',
                  // prettier-ignore
                  data: this.dailyElectricityDays
                }
              ],
              yAxis: [
                {
                  type: 'value'
                }
              ],
              series: [
                {
                  name: this.dailyElecMonth1,
                  type: 'bar',
                  data: staits,
                  itemStyle: {
                    color: '#9ACD32'
                  }
                },
                {
                  name: this.dailyElecMonth2,
                  type: 'bar',
                  data: lastStair,
                  itemStyle: {
                    color: '#00CED1'
                  }
                }
              ]
            }
            
          }
        });
      },
      //每日功率因数
      getDailyFactor(){
        getAction(this.url.dailyFactor, {startTime:this.month}).then(res => {
          if (res.success) {
            let barData = (res.result == null) ? [] : res.result.powerFactors
            let xAxis = (res.result == null ) ? [] : res.result.days
            this.dailyFactorOption = {
              tooltip: {
                trigger: 'axis'
              },
              xAxis: {
                type: 'category',
                data: xAxis,
                axisLabel: {
                  interval: 0
                }
              },
              yAxis: {
                type: 'value'
              },
              series: [{
                data: barData,
                name: '功率因数',
                type: 'line',
                barMaxWidth: 50,
                itemStyle: {
                  color: '#ccc400'
                },
                label: {
                  // 柱状图上方文本标签，默认展示数值信息
                  // show: true,
                  position: "top"
                }
              },
              ]
            }
          }
        });
      },
      //分项占比
      getItemProportion(){
        getAction(this.url.itemProportion, {startTime: this.timeRange[0], endTime:this.timeRange[1]}).then(res => {
          if (res.success) {
            let categoryElectricity = (res.result == null) ? [] : res.result.categoryElectricity
            let energyHisStatVos = (res.result == null ) ? [] : res.result.energyHisStatVos
            this.itemProportionOption = {
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)'
              },
              series: [
                {
                  type: 'pie',
                  radius: [0, '45%'],
                  label: {
                    position: 'inner',
                    fontSize: 14
                  },
                  labelLine: {
                    show: false
                  },
                  data: categoryElectricity.map((item, index) => ({
                      name: item.unitName,
                      value: item.dataValue || 0,
                  }))
                },
                {
                  type: 'pie',
                  radius: ['65%', '85%'],
                  labelLine: {
                    length: 30
                  },
                  label: {
                    position: 'inner',
                    fontSize: 14,
                    borderWidth: 1,
                    borderRadius: 4,
                    rich: {
                      a: {
                        color: '#6E7079',
                        lineHeight: 22,
                        align: 'center'
                      },
                      hr: {
                        borderColor: '#8C8D8E',
                        width: '100%',
                        borderWidth: 1,
                        height: 0
                      },
                      b: {
                        color: '#4C5058',
                        fontSize: 14,
                        fontWeight: 'bold',
                        lineHeight: 33
                      },
                      per: {
                        color: '#fff',
                        backgroundColor: '#4C5058',
                        padding: [3, 4],
                        borderRadius: 4
                      }
                    }
                  },
                  data: energyHisStatVos.map((item, index) => ({
                      name: item.unitName,
                      value: item.dataValue || 0,
                  }))
                }
              ]
            }
          }
        });
      },
      //用电最多Top10
      getMostElectricityTop10(){
        getAction(this.url.mostElectricityTop10, {startTime: this.timeRange[0], endTime:this.timeRange[1]}).then(res => {
          if (res.success && res.result) {
            this.rankList = res.result.map((item, index) => ({
                name: item.unitName,
                total: item.dataValue || 0,
            }))
          }
        });
      },
    }
  }
</script>

<style lang="less" scoped>
  .circle-cust {
    position: relative;
    top: 28px;
    left: -100%;
  }
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }

  /* 首页访问量统计 */
  .head-info {
    position: relative;
    text-align: left;
    padding: 0 32px 0 0;
    min-width: 125px;

    &.center {
      text-align: center;
      padding: 0 32px;
    }

    span {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      font-size: 0.95rem;
      line-height: 42px;
      margin-bottom: 4px;
    }
    p {
      line-height: 42px;
      margin: 0;
      a {
        font-weight: 600;
        font-size: 1rem;
      }
    }
  }

  .chart-card-header {
    position: relative;
    overflow: hidden;
    width: 100%;

    .meta {
      position: relative;
      overflow: hidden;
      width: 100%;
      color: rgba(0, 0, 0, .45);
      font-size: 14px;
      line-height: 22px;
    }
    .unit {
      position: relative;
      overflow: hidden;
      width: 100%;
      color: rgba(0, 0, 0, .85);
      font-size: 14px;
      line-height: 22px;
      margin-left: 30px;
    }

    .prefix {
      position: relative;
      overflow: hidden;
      width: 100%;
      color: rgba(0, 0, 0, .85);
      font-size: 14px;
      line-height: 22px;
      margin-left: 5px;
      margin-right: 30px;
    }

    .total {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      white-space: nowrap;
      color: #000;
      margin-top: 4px;
      margin-bottom: 0;
      font-size: 30px;
      line-height: 38px;
      height: 38px;
    }
  }

</style>